import api from '../../api/index'
import * as types from '../../types/index'

export default {
  state: {
    activeName: '2',
    frontApplyState: 2,
    pageCurrent: 1,
    loanListsData: [],
    pageCount: 1
  },
  getters: {
    [types.BROKER_ACTIVE_NAME]: state => state.activeName,
    [types.BROKER_FRONT_APPLY_STATE]: state => state.frontApplyState,
    [types.BROKER_PAGE_CURRENT]: state => state.pageCurrent,
    [types.BROKER_LOAN_LIST_DATA]: state => state.loanListsData,
    [types.BROKER_PAGE_COUNT]: state => state.pageCount
  },
  mutations: {
    [types.SET_BROKER_LOAN_LIST_DATA] (state, data) {
      state.loanListsData = data
    },
    [types.SET_BROKER_ACTIVE_NAME] (state, data) {
      state.activeName = data
    },
    [types.SET_BROKER_PAGE_CURRENT] (state, data) {
      state.pageCurrent = data
    },
    [types.SET_BROKER_FRONT_APPLY_STATE] (state, data) {
      state.frontApplyState = data
    },
    [types.SET_BROKER_PAGE_COUNT] (state, data) {
      state.pageCount = data
    }
  },
  actions: {
    [types.GET_BROKER_LOAN_LIST_DATA] ({commit}, params) {
      return api.getBrokerLoanData({
        token: params.token,
        frontApplyState: params.frontApplyState,
        pageCurrent: params.pageCurrent
      }).then((res) => {
        const resData = res.data
        commit(types.SET_BROKER_FRONT_APPLY_STATE, params.frontApplyState)
        if (Number(resData.code) === 0) {
          commit(types.SET_BROKER_PAGE_COUNT, resData.data.pageCount)
          commit(types.SET_BROKER_LOAN_LIST_DATA, resData.data.frontApplyList)
          commit(types.SET_BROKER_PAGE_CURRENT, params.pageCurrent)
        } else {
          commit(types.SET_BROKER_PAGE_COUNT, 0)
          commit(types.SET_BROKER_LOAN_LIST_DATA, [])
          commit(types.SET_BROKER_PAGE_CURRENT, 1)
        }
      })
    },
    [types.GET_BROKER_PAGE_CURRENT] ({commit}, params) {
      commit(types.SET_BROKER_PAGE_CURRENT, params.pageCurrent)
    },
    [types.DELETE_BROKER_LOAN_ITEM_FRONT_APPLY] ({dispatch, commit}, params) {
      return api.deleteLoanItemFrontApply({
        token: params.token,
        frontApplyId: params.frontApplyId,
        itemApplyId: params.itemApplyId
      }).then((res) => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          dispatch(types.SET_SUCCESS_MESSAGE, {
            show: true,
            content: resData.result
          })
        } else if (Number(resData.code) === 999) {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result
          })
          commit(types.SET_USER, {})
          params.router.push('/login')
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result || '当前借款删除失败'
          })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/brokerCenter/applicationList.js